import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { WriteQuestionnaire } from "@/types/questionnaire";
import {
  writeQuestionnaire,
  amendStatementsQuestionnaireSchema,
} from "@/schemas/questionnaire";
import { useFormUnsavedChangesWarning } from "@/hooks/useFormUnsavedChangesWarning";

export const useQuestionnaireForm = (
  questionnaire: WriteQuestionnaire,
  disabled = false,
  isAmendStatements = false,
) => {
  const schema = isAmendStatements
    ? amendStatementsQuestionnaireSchema
    : writeQuestionnaire;

  const form = useForm<WriteQuestionnaire>({
    resolver: zodResolver(schema),
    defaultValues: questionnaire,
    shouldUnregister: false,
    disabled,
    shouldFocusError: false,
  });
  useFormUnsavedChangesWarning(form);

  useEffect(() => {
    const errors = form.formState.errors;
    const [firstError] = Object.keys(errors);
    if (!firstError) return;

    // Find by id (used by custom components)
    const element =
      document.getElementById(firstError) ||
      // Find by name attribute (used by standard form inputs)
      document.querySelector(`[name="${firstError}"]`);

    if (element instanceof HTMLElement) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      element.focus({ preventScroll: true });
    }
  }, [form.formState.errors]);

  return form;
};
